import { Modal } from "antd";
import React from "react";
import { CloseIcon } from "../../../../Assets/icons";

const CommonModal: React.FC<{
  children: React.ReactNode;
  onCancel: (e: any) => void;
  visible: boolean;
}> = ({ children, onCancel, visible }) => {
  return (
    <Modal
      onCancel={onCancel}
      footer={null}
      open={visible}
      className="generalModal"
      closeIcon={<CloseIcon />}
    >
      {children}
    </Modal>
  );
};

export default CommonModal;
